import React, { useState } from 'react';

import { Box, Sheet, Tag } from '@betterment/samba-react';
import { toTitleCase } from '@betterment/shared-components/src/utils/StringHelpers';

import { EnvelopeAccountPendingOrdersQuery } from './graphql/envelopeAccountPendingOrders.generated';

import { Drawer } from '../../../activity/components/drawer/Drawer';
import { trackClick } from '../../../features/track';

type PendingOrder = NonNullable<
  Extract<EnvelopeAccountPendingOrdersQuery['account'], { __typename: 'DirectTradingAccount' }>['pendingOrders'][number]
>;

interface PendingOrderTagProps {
  item: PendingOrder;
}

export const PendingOrderTag: React.FC<PendingOrderTagProps> = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { security, tradeSide } = item;
  const { symbol } = security;
  const action = toTitleCase(tradeSide);

  const handlePillClick = () => {
    trackClick({ name: 'pendingOrderPill' });
  };

  return (
    <Sheet overlay="weak" open={isOpen} onOpenChange={setIsOpen}>
      <Sheet.Trigger asChild={true}>
        <Box css={{ cursor: 'pointer' }} onClick={handlePillClick}>
          <Tag
            accent="grey"
            css={{
              '& span': {
                textDecoration: 'underline',
                textDecorationSkipInk: 'none',
                textUnderlinePosition: 'from-font',
              },
            }}
          >
            {symbol} {action}
          </Tag>
        </Box>
      </Sheet.Trigger>

      <Sheet.Content
        css={{ overflowY: 'auto', gap: 'space.300', zIndex: '300' }}
        onOpenAutoFocus={e => e.preventDefault()}
      >
        <Drawer item={item} />
      </Sheet.Content>
    </Sheet>
  );
};
